import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  header: {
    id: 'pages.payments.header',
    defaultMessage: 'Profile',
  },
  description: {
    id: 'pages.payments.description',
    defaultMessage: 'Here you can edit your payment information. All fields are required.',
  },
  settings: {
    id: 'pages.payments.settings',
    defaultMessage: 'Settings',
  },
  paymentInfo: {
    id: 'pages.payments.paymentInfo',
    defaultMessage: 'Payment Info',
  },
  settingsHeader: {
    id: 'pages.payments.settingsHeader',
    defaultMessage: 'Your Settings',
  },
  paymentInfoHeader: {
    id: 'pages.payments.paymentInfoHeader',
    defaultMessage: 'Payment Information',
  },
});



// WEBPACK FOOTER //
// ./src/pages/ProfilePage/messages.js